// msalConfig.ts
import {
  BrowserCacheLocation,
  Configuration,
  PublicClientApplication,
} from "@azure/msal-browser";

// const msalConfig: Configuration = {
//   auth: {
//     clientId: "382818ac-e101-4867-8c68-64bac51240b0", // Azure AD App Client ID
//     authority: `https://login.microsoftonline.com/d44f2493-c06b-41d8-9ad8-4e4826a79c1f`, // Azure AD Tenant ID
//     redirectUri: "https://portaaltest.adite.be", // Your redirect URI
//   },
// };

const msalConfig: Configuration = {
  auth: {
    clientId: "6b14a9fd-0790-4fcc-a382-eece242cbb69", // Azure AD App Client ID
    authority: `https://login.microsoftonline.com/d44f2493-c06b-41d8-9ad8-4e4826a79c1f`, // Azure AD Tenant ID
    // redirectUri: "http://localhost:3000", // Your redirect URI
    redirectUri: "https://portaal.adite.be", // Your redirect URI
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, // "sessionStorage"
  },
};

// const msalConfig: Configuration = {
//   auth: {
//     clientId: "e2e4bf03-4234-4eb8-9d08-81001c9daf65", // Azure AD App Client ID
//     authority: `https://login.microsoftonline.com/221edafa-9224-4251-9623-2c3bb4858fb2`, // Azure AD Tenant ID
//     redirectUri: "https://portaaltest.adite.be", // Your redirect URI
//   },
// };

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["User.Read", "Sites.Read.All"], // Add necessary scopes
};
